/**
 * Product Tax Updater
 * Watches the product price and updates the tax display when variants change
 */

(function() {
  'use strict';

  var taxEnabled = window.Theme && window.Theme.settings && window.Theme.settings.enable_tax_display;
  var taxPercentage = window.Theme && window.Theme.settings && window.Theme.settings.tax_percentage;

  if (!taxEnabled || !taxPercentage || taxPercentage <= 0) {
    return;
  }

  function extractPrice(moneyString) {
    var numericString = moneyString.replace(/[^0-9.,]/g, '').replace(',', '');
    return parseFloat(numericString);
  }

  function formatMoney(amount) {
    return '$' + amount.toFixed(2);
  }

  function updateProductTax() {
    var priceElement = document.querySelector('[data-product-price]');
    var taxElement = document.querySelector('[data-product-tax]');
    
    if (!priceElement) {
      return;
    }

    var priceText = priceElement.textContent.trim();
    var price = extractPrice(priceText);
    
    if (isNaN(price) || price <= 0) {
      if (taxElement) {
        taxElement.style.display = 'none';
      }
      return;
    }

    var taxMultiplier = (100 + taxPercentage) / 100;
    var totalWithTax = price * taxMultiplier;
    var formattedTax = formatMoney(totalWithTax);

    if (taxElement) {
      taxElement.textContent = '(' + formattedTax + ' inc tax)';
      taxElement.style.display = 'inline';
    } else {
      var priceContainer = priceElement.closest('.product__price');
      if (priceContainer) {
        var newTaxElement = document.createElement('span');
        newTaxElement.className = 'money money--tax';
        newTaxElement.setAttribute('data-product-tax', '');
        newTaxElement.textContent = '(' + formattedTax + ' inc tax)';
        priceElement.parentNode.insertBefore(newTaxElement, priceElement.nextSibling);
      }
    }
  }

  var priceElement = document.querySelector('[data-product-price]');
  
  if (priceElement) {
    var observer = new MutationObserver(function(mutations) {
      updateProductTax();
    });

    observer.observe(priceElement, {
      characterData: true,
      childList: true,
      subtree: true
    });

    var productForm = document.querySelector('[data-product-form]');
    if (productForm) {
      productForm.addEventListener('change', function(e) {
        if (e.target.hasAttribute('data-product-option') || e.target.hasAttribute('data-variants')) {
          setTimeout(updateProductTax, 100);
        }
      });
    }

    updateProductTax();
  }

})();

